import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import ExportFormCompta from './Comp/ExportFormCompta'
import HistoExportPeriode from './Comp/HistoExportPeriode'

const AchatVenteExport = (props) => {
    const t = useTranslate();
    const [reload,setReload] = useState(Date.now())

    return(
        <div className='row'>
            <div className="col-3 d-flex">
                <ExportFormCompta 
                    setReload={setReload}
                    exportBtnTitle={props.exportBtnTitle}
                    exportEndUrl={props.exportEndUrl}
                    controlCompta={props.controlCompta}
                />
            </div>
            <div className="col-9 d-flex">
                <HistoExportPeriode
                    exportType={props.exportType}
                    reload={reload}
                />
            </div>
        </div>
    )
}

export default AchatVenteExport;